import { useQuery } from '@tanstack/react-query';
import { useCan } from '@/hooks/useCan';
import { stockTransfersApi } from '@/api/stock-transfers.api';

export const TRANSFER_COUNTS_KEY = ['stock-transfers', 'pending-counts'];

/**
 * Open transfers touching the person's branches, for the nav badge. Requests
 * waiting for approval count only for someone who can approve them.
 */
export function useOpenTransferCount() {
  const { canView, canManage } = useCan();
  const q = useQuery({
    queryKey: TRANSFER_COUNTS_KEY,
    queryFn: () => stockTransfersApi.pendingCounts(),
    enabled: canView('inventory'),
    staleTime: 60_000,
  });
  const c = q.data;
  if (!c) return 0;
  return (
    (canManage('stock_transfer_approval') ? c.REQUESTED : 0) +
    c.APPROVED +
    c.IN_TRANSIT
  );
}
